<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="80px">
        <el-row :gutter="20">

          <el-col :span="6">
            <el-form-item label="商品信息：商品标题" prop="goodsTitle">
              <el-input v-model="queryForm.goodsTitle" placeholder="请输入商品信息：商品标题"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品缩略图地址" prop="goodsImgUrl">
              <el-input v-model="queryForm.goodsImgUrl" placeholder="请输入商品缩略图地址"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品平台url" prop="goodsUrl">
              <el-input v-model="queryForm.goodsUrl" placeholder="请输入商品平台url"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="拍下单价" prop="buyPrice">
              <el-input v-model="queryForm.buyPrice" placeholder="请输入拍下单价"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="每单拍下数量" prop="buyNumbers">
              <el-input v-model="queryForm.buyNumbers" placeholder="请输入每单拍下数量"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品展示价格" prop="showPrice">
              <el-input v-model="queryForm.showPrice" placeholder="请输入商品展示价格"/>
            </el-form-item>
          </el-col>

          <el-col :span="6" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('新增字典项')">新增</el-button>


      <el-table :data="tableData" border default-expand-all stripe style="width: 100%;margin-bottom: 20px;">

        <el-table-column prop="id" label="" />
        <el-table-column prop="goodsTitle" label="商品信息：商品标题" />
        <el-table-column prop="goodsImgUrl" label="商品缩略图地址" />
        <el-table-column prop="goodsUrl" label="商品平台url" />
        <el-table-column prop="buyPrice" label="拍下单价" />
        <el-table-column prop="buyNumbers" label="每单拍下数量" />
        <el-table-column prop="showPrice" label="商品展示价格" />
        <el-table-column prop="goodsQuanUrl" label="优惠券链接" />
        <el-table-column prop="isExpress" label="是否包邮，0不包邮， 1包邮" />
        <el-table-column prop="expressName" label="物流公司名称" />
        <el-table-column prop="goodsSort" label="商品排序方式：0综合， 1销量" />
        <el-table-column prop="getGoodsPersons" label="商品现有收货人或付款人数" />
        <el-table-column prop="goodsPriceRange" label="商品价格区间 例：2300.00-3200.00" />
        <el-table-column prop="goodsLocation" label="商品所在地" />
        <el-table-column prop="goodsAnswers" label="宝贝详情问答" />
        <el-table-column prop="orderContent" label="订单留言" />
        <el-table-column prop="createBy" label="创建者" />
        <el-table-column prop="createTime" label="" />
        <el-table-column prop="updateBy" label="修改者" />
        <el-table-column prop="updateTiem" label="" />
        <el-table-column prop="remarks" label="" />
        <el-table-column prop="b2cTasksId" label="" />

        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle
                       @click="handleEdit(scope.$index, scope.row,'修改字典项')"/>
            <el-button size="mini" type="danger" icon="el-icon-delete" circle
                       @click="handleDelete(scope.$index, scope.row)"/>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible"
               :before-close="beforeDialogClose">
      <el-form :model="dialogForm" ref="dialogForm"
               :rules="dialogFormRules" label-width="100px">

        <el-form-item label="商品信息：商品标题" prop="goodsTitle">
            <el-input v-model="dialogForm.goodsTitle" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品缩略图地址" prop="goodsImgUrl">
            <el-input v-model="dialogForm.goodsImgUrl" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品平台url" prop="goodsUrl">
            <el-input v-model="dialogForm.goodsUrl" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="拍下单价" prop="buyPrice">
            <el-input v-model="dialogForm.buyPrice" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="每单拍下数量" prop="buyNumbers">
            <el-input v-model="dialogForm.buyNumbers" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品展示价格" prop="showPrice">
            <el-input v-model="dialogForm.showPrice" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="优惠券链接" prop="goodsQuanUrl">
            <el-input v-model="dialogForm.goodsQuanUrl" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否包邮，0不包邮， 1包邮" prop="isExpress">
            <el-input v-model="dialogForm.isExpress" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="物流公司名称" prop="expressName">
            <el-input v-model="dialogForm.expressName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品排序方式：0综合， 1销量" prop="goodsSort">
            <el-input v-model="dialogForm.goodsSort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品现有收货人或付款人数" prop="getGoodsPersons">
            <el-input v-model="dialogForm.getGoodsPersons" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品价格区间 例：2300.00-3200.00" prop="goodsPriceRange">
            <el-input v-model="dialogForm.goodsPriceRange" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品所在地" prop="goodsLocation">
            <el-input v-model="dialogForm.goodsLocation" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="宝贝详情问答" prop="goodsAnswers">
            <el-input v-model="dialogForm.goodsAnswers" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="订单留言" prop="orderContent">
            <el-input v-model="dialogForm.orderContent" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="修改者" prop="updateBy">
            <el-input v-model="dialogForm.updateBy" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="updateTiem">
            <el-input v-model="dialogForm.updateTiem" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="remarks">
            <el-input v-model="dialogForm.remarks" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="b2cTasksId">
            <el-input v-model="dialogForm.b2cTasksId" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm" size="mini" type="primary">确 定</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {getAllB2cGoods,getB2cGoods,updateB2cGoods,addB2cGoods,deleteB2cGoods}
  from '../../api/b2cbusiness/b2c_goods'

  import MixinCUD from '@/components/MixinCUD'

  export default {
    mixins:[MixinCUD],
    data() {
      return {
        tableData: [],
        queryFormRefName:"queryForm",
        queryForm:{
          goodsTitle: '',
          goodsImgUrl: '',
          goodsUrl: '',
          buyPrice: '',
          buyNumbers: '',
          showPrice: '',
        },
        dialogFormVisible: false,
        dialogTitle:"",
        dialogRefName:"dialogForm",
        dialogForm: {
          id: null,
          goodsTitle: '',
          goodsImgUrl: '',
          goodsUrl: '',
          buyPrice: '',
          buyNumbers: '',
          showPrice: '',
          goodsQuanUrl: '',
          isExpress: '',
          expressName: '',
          goodsSort: '',
          getGoodsPersons: '',
          goodsPriceRange: '',
          goodsLocation: '',
          goodsAnswers: '',
          orderContent: '',
          updateBy: '',
          updateTiem: '',
          remarks: '',
          b2cTasksId: '',
        },
        dialogFormRules: {
          goodsTitle :[{required: true, message: '请输入商品信息：商品标题', trigger: 'blur'}, { max: 128 , message: '最大长度128', trigger: 'change'},],
          goodsImgUrl :[{required: true, message: '请输入商品缩略图地址', trigger: 'blur'}, { max: 128 , message: '最大长度128', trigger: 'change'},],
          goodsUrl :[{required: true, message: '请输入商品平台url', trigger: 'blur'}, { max: 128 , message: '最大长度128', trigger: 'change'},],
          buyPrice :[{required: true, message: '请输入拍下单价', trigger: 'blur'}, { max: null , message: '最大长度null', trigger: 'change'},],
          buyNumbers :[{required: true, message: '请输入每单拍下数量', trigger: 'blur'}, { max: null , message: '最大长度null', trigger: 'change'},],
          showPrice :[{required: true, message: '请输入商品展示价格', trigger: 'blur'}, { max: null , message: '最大长度null', trigger: 'change'},],
          goodsQuanUrl :[ { max: 128 , message: '最大长度128', trigger: 'change'},],
          isExpress :[{required: true, message: '请输入是否包邮，0不包邮， 1包邮', trigger: 'blur'}, { max: null , message: '最大长度null', trigger: 'change'},],
          expressName :[{required: true, message: '请输入物流公司名称', trigger: 'blur'}, { max: 128 , message: '最大长度128', trigger: 'change'},],
          goodsSort :[{required: true, message: '请输入商品排序方式：0综合， 1销量', trigger: 'blur'}, { max: null , message: '最大长度null', trigger: 'change'},],
          getGoodsPersons :[ { max: null , message: '最大长度null', trigger: 'change'},],
          goodsPriceRange :[ { max: 45 , message: '最大长度45', trigger: 'change'},],
          goodsLocation :[ { max: 45 , message: '最大长度45', trigger: 'change'},],
          goodsAnswers :[ { max: 128 , message: '最大长度128', trigger: 'change'},],
          orderContent :[ { max: 45 , message: '最大长度45', trigger: 'change'},],
          updateBy :[{required: true, message: '请输入修改者', trigger: 'blur'}, { max: 45 , message: '最大长度45', trigger: 'change'},],
          updateTiem :[{required: true, message: '请输入', trigger: 'blur'}, { max: null , message: '最大长度null', trigger: 'change'},],
          remarks :[ { max: 255 , message: '最大长度255', trigger: 'change'},],
          b2cTasksId :[{required: true, message: '请输入', trigger: 'blur'}, { max: null , message: '最大长度null', trigger: 'change'},],
        }
      }
    },
    methods: {
      getData(){
        getB2cGoods(
        this.queryForm.goodsTitle,
        this.queryForm.goodsImgUrl,
        this.queryForm.goodsUrl,
        this.queryForm.buyPrice,
        this.queryForm.buyNumbers,
        this.queryForm.showPrice)
          .then(res => {
            this.setData(res)
          })
      },
      updateData(){
        updateB2cGoods(this.dialogForm)
          .then(res => {
            this.$message({message: res.data, type: 'success'});
            this.submitQueryForm();//修改之后，重新查询table
            this.handleCloseDialog();
          })
      },
      addData(){
        addB2cGoods(this.dialogForm).then(res => {
          this.$message({message: res.data, type: 'success'});
          this.submitQueryForm();//新增之后，重新查询table
          this.handleCloseDialog();
        })
      },
      deleteData(row){
        this.$confirm("确定删除?")
          .then(_ => {
            deleteB2cGoods(row.id)
              .then(res => {
                this.submitQueryForm();//删除之后，重新查询table
                this.$message({message: res.data, type: 'success'});
              }).catch(err => {
                this.$message({message: err.message, type: 'success'});
              })
          });
      },
      setData(res) {
        if (res.isSuccess) {
          this.tableData = res.data
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      getAllB2cGoods().then(res => {
        next(vm => vm.setData(res))
      })
    }
  }
</script>

<style scoped>
  .el-form {
    margin-top: 20px;
  }
</style>
